export default __webpack_public_path__ + "static/media/tamilheros.9f862da5.png";